<template>
    <div class="view relative text-dark-blue">
        <Header/>
        <div>
            <slot/>
        </div>
    </div>
</template>


<script setup lang="ts">
    import Header from "~/components/view/Header.vue"
    const router = useRouter()
    const config = useRuntimeConfig()
    const mainStore = useMainStore()
    const { locale } = useI18n()
    const i18nHead = useLocaleHead({ seo: true })

    // Localized CMS values are read through mainStore.active_locale; keep it in step with the site's i18n locale.
    watch(locale, (value) => {
        mainStore.$patch({ active_locale: value === 'nl' ? 'nl_NL' : 'en_GB' })
    }, {
        immediate: true,
        flush: 'sync'
    })

    useHead(() => ({
        htmlAttrs: {
            ...i18nHead.value.htmlAttrs,
            class: 'view-layout light'
        },
        link: i18nHead.value.link,
        meta: i18nHead.value.meta
    }))

    useSeoMeta({
        title: "YIPP",
        titleTemplate: "%s · YIPP",

        // Open Graph (Facebook, LinkedIn, Slack, iMessage previews)
        ogType: 'website',
        ogSiteName: 'YIPP',
        ogTitle: 'Digital Exhibition & Immersive Studio',
        ogDescription: 'We design and produce playful digital interactives for a world of curious people',
        ogImage: `${config.public.publicHost}/images/openg_yipp.jpg`,  // 1200×630px, absolute URL

        // Twitter / X card
        twitterCard: 'summary_large_image',
        twitterTitle: 'YIPP',
        twitterDescription: 'We design and produce playful digital interactives for a world of curious people',
        twitterImage: `${config.public.publicHost}/images/openg_yipp.jpg`,
    })

    onMounted(() => {
        if (!navigator.webdriver) {
            Analytics.set_dev_mode(import.meta.dev)
            Analytics.set_interval(90_000)
            Analytics.init()
            Analytics.start_session(router.currentRoute.value)
        }
    })
</script>

<style lang="scss">
    .fade-enter-active,
    .fade-leave-active {
        transition: all 0.2s;
    }
    .fade-enter-from,
    .fade-leave-to {
        opacity: 0;
        //filter: blur(1rem);
    }
</style>
